import React, { useEffect, useState } from "react";
import "../styles/interview-wizard.scss";
import { connect, ReactReduxContext } from "react-redux";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import { Birdseed } from "@coverme/elements";
import { InterviewPersonalContainer } from "./InterviewWizard/InterviewPersonal/InterviewPersonalContainer";
import { InterviewSidebarContainer } from "./InterviewWizard/InterviewSidebar/InterviewSidebar";
import { InterviewCoverageContainer } from "./InterviewWizard/InterviewCoverage/InterviewCoverageContainer";
import { InterviewCoverageSummaryContainer } from "./InterviewWizard/InterviewCoverageSummary/InterviewCoverageSummary";
import { InterviewPatientScreeningContainer } from "./InterviewWizard/PatientInfoScreeningContainer/PatientInfoScreeningContainer";
import { InterviewHouseholdBuilderContainer } from "./InterviewWizard/InterviewHouseholdBuilder/InterviewHouseholdBuilderContainer";
import {
    AddHouseholdMemberContainer,
    EditHouseholdMemberContainer,
} from "./InterviewWizard/InterviewHouseholdBuilder/HouseholdMemberContainer";
import { InterviewPersonInfoScreeningContainer } from "./InterviewWizard/InterviewPersonInfoScreening/InterviewPersonInfoScreeningContainer";
import { InterviewDocumentsContainer } from "./InterviewWizard/InterviewDocumentation/InterviewDocumentsContainer";
import * as documentActions from "../actions/documentActions";
import { isNullOrWhitespace } from "../services/stringService";
import * as interviewWizardService from "./InterviewWizard/services/interviewWizardService";
import { InterviewInitializationComponent } from "./InterviewWizard/InterviewInitialization/InterviewInitialization";
import * as personActions from "../actions/personActions";
import * as personNotesActions from "../actions/personNotesActions";
import * as lookupActions from "../actions/lookupActions";
import { withUser } from "@coverme/identity";
import { TerminateInterviewContainer } from "./TerminateInterviewContainer";
import { InterviewContractConsentContainer } from "./InterviewWizard/InterviewContractConsent/InterviewContractConsentContainer";
import { InterviewExchangeContainer } from "./InterviewWizard/InterviewExchange/InterviewExchangeContainer";
import * as assistanceCategoryActions from "../actions/assistaceCategoriesActions";
import { shouldShowContractConsent } from "../services/contractService";
import { isCallCenterUser } from "../services/userService";
import * as interviewActions from "../actions/interviewActions";
import { InterviewGovernmentContainer } from "./InterviewWizard/InterviewGovernment/InterviewGovernmentContainer";
import * as wizardStatusActions from "../actions/wizardStatusActions";
import { InterviewFinancialAssistanceContainer } from "./InterviewWizard/InterviewFinancialAssistance/InterviewFinancialAssistanceContainer";
import { InterviewDataVerificationContainer } from "./Verification/DataVerificationContainers";
import { LongTermCareContainer } from "./InterviewWizard/LongTermCare/LongTermCareContainer";
import { InterviewFormsAndApplicationsContainer }  from "./InterviewWizard/InterviewFormsAndApplications/InterviewFormsAndApplicationsContainer";
import { getInterview } from "../actions/interviewActions";

function isInterviewLoading(customer, encounterId, interview, lookups) {
    let isLoading = false;
    if (customer.isInitialized === false || customer.isLoading === true) {
        isLoading = true;
    }

    if (encounterId != null && interview.encounterId == null) {
        isLoading = true;
    }

    if (lookups.isInitialized === false || lookups.isLoading === true) {
        isLoading = true;
    }
    return isLoading;
}

const InterviewWizard = ({
    encounterId,
    interview,
    lookups,
    customer,
    getPerson,
    match,
    history,
    documents,
    getDocuments,
    getNotes,
    myStore,
    user,
    assistanceCategories,
    person,
    resetInterview,
    getProgramSections,
    setSectionComplete,
    getLookups,
}) => {
    const [currentSection, setCurrentSection] = useState("");
    const personId = person?.globalId;
    const interviewPersonId = interview?.entry?.patient?.personId;

    useEffect(() => {
        if (customer.isInitialized === false || customer.isLoading === true) {
            return;
        }

        if (lookups.isInitialized === false) {
            getLookups(customer?.data?.customer?.GlobalId, customer.data.jurisdictions);
        }
    }, [customer, getLookups, lookups.isInitialized]);

    useEffect(() => {
        if (customer.isInitialized === false || customer.isLoading === true) {
            return;
        }
        if (isNullOrWhitespace(interview?.entry?.patient?.personId)) {
            return;
        }
        if (personId != null) {
            return;
        }
        setTimeout(() => {
            getDocuments(customer?.data?.customer?.GlobalId, interviewPersonId);
            getPerson(customer?.data?.customer?.GlobalId, interviewPersonId);
        }, 500);
    }, [interviewPersonId, currentSection, customer]);

    useEffect(() => {
        if (personId != null) {
            getNotes(customer?.data?.customer?.code, personId);
        }
    }, [personId]);

    useEffect(() => {
        return () => {
            if (encounterId == null) {
                resetInterview();
            }
        };
    }, []);

    function onSubmitComplete(value, result) {
        getInterview(customer?.data?.customer?.GlobalId, encounterId);
        let updatedInterview = myStore.getState().interview;
        if (encounterId != null) {
            const nextPage = interviewWizardService.getNextPage(
                match.url,
                currentSection,
                updatedInterview,
                lookups.data.configuration,
                assistanceCategories,
                user,
                person,
                customer,
                value === true
            );
            return history.push(nextPage);
        } else {
            if (shouldShowContractConsent(updatedInterview) && !isCallCenterUser(user)) {
                return history.push(`/interview/${result.encounterId}/contractConsent`);
            } else {
                return history.push(`/interview/${result.encounterId}/verification`);
            }
        }
    }

    function onFinancialInfoCollected(value, result) {
        let updatedInterview = myStore.getState().interview;
        getProgramSections(updatedInterview.encounterId).then(data => {
            let configuration = myStore.getState().interviewLookups.data.configuration;
            const nextPage = interviewWizardService.getNextPage(
                match.url,
                currentSection,
                interview,
                configuration,
                assistanceCategories,
                user,
                person,
                customer,
                value === true
            );

            return history.push(nextPage);
        });
    }

    function currentSectionMapping(currentSection) {
        switch (currentSection) {
            case "entry":
                return "Patient Information";
            case "coverage":
                return "Coverage";
            case "patientInfoScreening":
                return "Program Detection";
            case "householdMatrix":
                return "Household";
            case "personInfoScreening":
                return "Financial";
            case "longTermCare":
                return "Long Term Care";
            case "exchange":
                return "Exchange";
            case "documentation":
                return "Documents";
            case "formsAndApplications":
                return "Forms & Applications";
            default:
                return "";
        }
    }

    function onPrevious() {
        const updatedInterview = myStore.getState().interview;
        const previousPage = interviewWizardService.getPreviousPage(
            match.url,
            currentSection,
            interview,
            lookups.data.configuration,
            assistanceCategories,
            user,
            person,
            customer
        );
        return history.push(previousPage);
    }

    return (
        <>
            <Birdseed>
                <Link to={"/"}>Home</Link>
                <a href="javascript:void(0)">
                    Interview / <strong>{currentSectionMapping(currentSection)}</strong>{" "}
                </a>
            </Birdseed>
            <div className="interview-wizard">
                <InterviewSidebarContainer currentSection={currentSection} />
                <div className="interview-wizard-content">
                    <Route
                        path={`${match.path}`}
                        exact
                        render={props => {
                            return (
                                <InterviewInitializationComponent
                                    {...props}
                                    currentSection={currentSection}
                                    interview={interview}
                                    lookups={lookups}
                                    match={match}
                                    history={history}
                                    customerId={customer?.data?.customer?.GlobalId}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/entry`}
                        render={props => {
                            setCurrentSection("entry");
                            return <InterviewPersonalContainer {...props} navigateToNextPage={onSubmitComplete} />;
                        }}
                    />
                    <Route
                        path={`${match.path}/verification`}
                        render={props => {
                            setCurrentSection("verification");
                            return (
                                <InterviewDataVerificationContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/contractConsent`}
                        render={props => {
                            setCurrentSection("contractConsent");
                            return (
                                <InterviewContractConsentContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/coverage`}
                        exact
                        render={props => {
                            setCurrentSection("coverage");
                            return (
                                <InterviewCoverageContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/patientInfoScreening`}
                        render={props => {
                            setCurrentSection("patientInfoScreening");
                            return (
                                <InterviewPatientScreeningContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/household-builder`}
                        exact
                        render={props => {
                            setCurrentSection("householdMatrix");
                            return (
                                <InterviewHouseholdBuilderContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Switch>
                        <Route
                            path={`${match.path}/household-builder/add`}
                            exact
                            render={props => <AddHouseholdMemberContainer {...props} />}
                        />
                        <Route
                            path={`${match.path}/household-builder/:personId`}
                            exact
                            render={props => <EditHouseholdMemberContainer {...props} />}
                        />
                    </Switch>
                    <Route
                        path={`${match.path}/personInfoScreening`}
                        exact
                        render={props => {
                            setCurrentSection("personInfoScreening");
                            return (
                                <InterviewPersonInfoScreeningContainer
                                    {...props}
                                    navigateToNextPage={onFinancialInfoCollected}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/government`}
                        exact
                        render={props => {
                            setCurrentSection("government");
                            return (
                                <InterviewGovernmentContainer
                                    {...props}
                                    navigateToNextPage={(value, result) => {
                                        setSectionComplete("government");
                                        onSubmitComplete(value, result);
                                    }}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/financialAssistance`}
                        exact
                        render={props => {
                            setCurrentSection("financialAssistance");
                            return (
                                <InterviewFinancialAssistanceContainer
                                    {...props}
                                    currentSection={currentSection}
                                    navigateToNextPage={(value, result) => {
                                        setSectionComplete("financialAssistance");
                                        onSubmitComplete(value, result);
                                    }}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/longTermCare`}
                        exact
                        render={props => {
                            setCurrentSection("longTermCare");
                            return (
                                <LongTermCareContainer
                                    {...props}
                                    currentSection={currentSection}
                                    navigateToNextPage={(value, result) => {
                                        setSectionComplete("longTermCare");
                                        onSubmitComplete(value, result);
                                    }}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/exchange`}
                        exact
                        render={props => {
                            setCurrentSection("exchange");
                            return (
                                <InterviewExchangeContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/documentation`}
                        exact
                        render={props => {
                            setCurrentSection("documentation");
                            return (
                                <InterviewDocumentsContainer
                                    {...props}
                                    navigateToNextPage={onSubmitComplete}
                                    navigateToPreviousPage={onPrevious}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/thankyou`}
                        exact
                        render={props => {
                            setCurrentSection("thankyou");
                            return <TerminateInterviewContainer {...props} navigateToNextPage={onSubmitComplete} />;
                        }}
                    />
                     <Route
                        path={`${match.path}/formsAndApplications`}
                        exact
                        render={props => {
                            setCurrentSection("formsAndApplications");
                            return (
                                <InterviewFormsAndApplicationsContainer
                                    {...props}
                                />
                            );
                        }}
                    />
                </div>
            </div>
        </>
    );
};

const InterviewWizardWithRoute = withRouter(InterviewWizard);

// The code below is a hack. https://react-redux.js.org/using-react-redux/accessing-store#using-reactreduxcontext-directly
// I can't find a better way to do it
const InterviewWizardWithCustomStore = props => {
    return (
        <ReactReduxContext.Consumer>
            {({ store }) => <InterviewWizardWithRoute {...props} myStore={store} />}
        </ReactReduxContext.Consumer>
    );
};
const InterviewWizardWithUser = withUser(InterviewWizardWithCustomStore);

export const EditInterviewWizardContainer = connect(
    (state, ownProps) => {
        let person = null;
        let externalPersonId = state?.interview?.entry?.patient?.personId;
        if (externalPersonId != null) {
            person = state.person.data[externalPersonId];
        }
        return {
            encounterId: ownProps?.match?.params?.encounterId,
            interview: state.interview,
            lookups: state.interviewLookups,
            person: person,
            customer: state.customer,
            documents: state.documents,
            assistanceCategories: state.assistanceCategories.data,
        };
    },
    dispatch => ({
        getDocuments: (customerId, personId) => dispatch(documentActions.getDocuments(customerId, personId)),
        getPerson: (customerId, patientId) => dispatch(personActions.getPerson(customerId, patientId)),
        getNotes: (customerCode, personId) => dispatch(personNotesActions.getNotes(customerCode, personId)),
        getProgramSections: interviewId => dispatch(lookupActions.getProgramSections(interviewId)),
        setSectionComplete: section => dispatch(wizardStatusActions.setSectionComplete(section)),
        getLookups: (customerId, jurisdiction) => dispatch(lookupActions.getLookups(customerId, jurisdiction)),
    })
)(InterviewWizardWithUser);

export const AddInterviewWizardContainer = connect(
    (state, ownProps) => ({
        encounterId: null,
        interview: state.interview,
        person: null,
        lookups: state.interviewLookups,
        customer: state.customer,
        documents: state.documents,
        assistanceCategories: state.assistanceCategories.data,
    }),
    dispatch => ({
        getDocuments: (customerId, personId) => dispatch(documentActions.getDocuments(customerId, personId)),
        getPerson: (customerId, patientId) => dispatch(personActions.getPerson(customerId, patientId)),
        getNotes: (customerCode, personId) => dispatch(personNotesActions.getNotes(customerCode, personId)),
        resetInterview: () => dispatch(interviewActions.resetInterview()),
        getLookups: (customerId, jurisdiction) => dispatch(lookupActions.getLookups(customerId, jurisdiction)),
    })
)(InterviewWizardWithUser);
